import { connect } from 'react-redux';

import { fetchProjects, fetchProjectsFilters } from 'client/ducks/projects-page/actions';
import {
    isLoading,
    hasMoreProjects,
    getProjects,
    getProjectsMeta,
    getFilterYears,
    getProjectsParams
} from 'client/ducks/projects-page/selectors';
import { State } from 'client/store';

import ProjectsListPage, { DispatchProps, Props } from './projects-page';

function mapStateToProps(state: State): Partial<Props> {
    return {
        hasMore: hasMoreProjects(state),
        years: getFilterYears(state),
        rows: getProjects(state),
        meta: getProjectsMeta(state),
        listParams: getProjectsParams(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = {
    fetchProjects,
    fetchFilters: fetchProjectsFilters
};

export default connect<Partial<Props>, DispatchProps>(mapStateToProps, mapDispatchToProps)(ProjectsListPage);
